module.exports = __webpack_public_path__ + "img/icon_z2.bbdab64.png";